import { z } from 'zod';
export var ModalTypeSchema = z.enum([
    'ACTIVITY_NOTIFICATION',
    'ADD_PLAYER',
    'EDIT_PLAYER',
    'ADD_PRODUCT',
    'EDIT_PRODUCT',
    'ADD_GAME_PRODUCT',
    'ADD_TEAM',
    'EDIT_TEAM',
    'ADD_USER',
    'ADD_GAME',
    'EDIT_GAME',
    'SCORE'
]);
export var ModalStateDataSchema = z.object({
    type: ModalTypeSchema.nullable().default(ModalTypeSchema.Enum.ADD_PRODUCT),
    isVisible: z.boolean().default(false),
    payload: z.unknown().default({})
});
